import styled from "styled-components";
import Paper from "@mui/material/Paper";
import { Box, InputBase } from "@mui/material";
import { theme } from "styles/mui-config";
import Button from "@mui/material/Button";

export const StyledMainPaper = styled(Paper)`
  width: 100%;
  height: auto;
  position: relative;
`;

export const StyledDeleteDiv = styled.div`
  width: 36px;
  height: 36px;
  border-bottom-right-radius: 15px;
  border-right: 1px solid #ff7979;
  color: #ff7979;
  border-bottom: 1px solid #ff7979;
  padding: 5px;
  transition: 0.3s;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ff7979;
  cursor: pointer;

  &:hover {
    background-color: #ff7979;
    color: rgba(224, 224, 224);
  }
`;

export const StyledMainDivFlex = styled.div`
  display: flex;
  justify-content: flex-start;
`;

export const StyledMainDivImageAndInfo = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledMainDivCount = styled.div`
  width: 100px;
  // height: 50px;
  position: absolute;
  bottom: 20px;
  left: 15px;
`;

export const StyledInput = styled(InputBase)`
  height: 10px !important;
  font-size: 16px !important;
  width: 40px;
  text-align: center;
  & * {
    text-align: center;
    border-bottom: 2px solid ${theme.palette.primary.dark} !important;
  }
`;
export const AddProductWrapper = styled(Box)`
  width: 100px !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  &:nth-child(2) {
    background-color: white;
  }
`;
export const IconWrapper = styled(Box)`
  background-color: ${theme.palette.primary.main};
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  border-radius: 5px;
  padding: 1px;
  cursor: pointer;
  &:hover {
    background-color: ${theme.palette.primary.dark};
  }
`;

export const StyledImageDiv = styled.div`
  width: 200px;
  height: 200px;
  padding: 15px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 1020px) {
    width: 160px;
    height: 160px;
  }

  @media screen and (max-width: 485px) {
    width: 140px;
    height: 140px;
  }
`;

export const StyledProductInfoDiv = styled.div`
  flex-direction: column;
  margin-right: 20px;
`;

export const StyledProductTitle = styled.p`
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  color: rgb(0, 74, 94);
  font-family: Avini;
  padding-left: 44px;
  margin-bottom: 0;
  @media screen and (max-width: 580px) {
    font-size: 19px;
  }

  @media screen and (max-width: 533px) {
    font-size: 15px;
  }
`;

export const StyledProductTitleColor = styled.p`
  font-style: normal;
  font-size: 19px;
  color: rgb(170, 170, 170);
  font-family: Avini;
  padding-left: 44px;
  display: flex;
  align-items: center;
  margin: 0;
  & span:nth-child(2) {
    display: inline-block;
    width: 20px !important;
    height: 20px !important;
    border-radius: 100%;
    border: 1px solid #808080ab;
    margin-right: 7px;
  }
  @media screen and (max-width: 580px) {
    font-size: 16px;
  }

  @media screen and (max-width: 533px) {
    font-size: 12px;
  }
`;

export const StyledProductPrice = styled.p`
  color: rgb(0, 154, 194);
  font-style: normal;
  font-weight: 400;
  font-size: 18px;

  @media screen and (max-width: 533px) {
    font-size: 15px;
  }

  @media screen and (max-width: 401px) {
    font-size: 13px;
    margin-bottom: 66px;
  }
`;
